(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maxgen-practitioner-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maxgen-practitioner-form')) {
    class MaxgenPractitionerForm extends HTMLElement {
      constructor() {
        super();
        this.frame = null;
        this.receiveHeight = this.receiveHeight.bind(this);
      }

      connectedCallback() {
        if (this.frame) return;
        this.frame = this.querySelector('iframe');
        if (!this.frame) return;

        // Listen before navigation so the portal's first height is received.
        window.addEventListener('message', this.receiveHeight);
        if (!this.frame.hasAttribute('src')) {
          this.frame.src = 'https://portal.maxgenlabs.com/apply/maxgen.html';
        }
        this.frame.hidden = false;
      }

      disconnectedCallback() {
        window.removeEventListener('message', this.receiveHeight);
        this.frame = null;
      }

      receiveHeight(event) {
        if (
          !this.frame ||
          event.origin !== 'https://portal.maxgenlabs.com' ||
          event.source !== this.frame.contentWindow
        ) return;

        const data = event.data;
        if (data && data.mgApply === 'focus' && data.brand === 'maxgen' && data.target === 'confirmation') {
          this.scrollIntoView({ behavior: 'auto', block: 'start' });
          return;
        }
        if (
          !data ||
          typeof data !== 'object' ||
          data.mgApply !== 'height' ||
          data.brand !== 'maxgen' ||
          typeof data.value !== 'number' ||
          !Number.isFinite(data.value) ||
          data.value <= 0 ||
          data.value > 100000
        ) return;

        this.frame.style.height = Math.max(240, Math.ceil(data.value)) + 'px';
      }
    }

    customElements.define('maxgen-practitioner-form', MaxgenPractitionerForm);
  }

  } catch(e) { console.error(e); }
})();
})();
